import { jsxs as m, jsx as l } from "react/jsx-runtime";
import { forwardRef as _, useRef as M } from "react";
import { u as a } from "./index-6a632112.mjs";
import { u as D } from "./uniqueId-321287e8.mjs";
import { s as n, r as T, e, d as E } from "./themes-5f0b3c3d.mjs";
import { l as F } from "./lineHeights-72d3110c.mjs";
import { t as j } from "./textStyles-42cab346.mjs";
import { useAccessibilityProps as A } from "./accessibility.js";
import { L as R } from "./label-3b996c7d.mjs";
import { H as X } from "./helperText-698f3ed9.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./warningFilled-691cfde1.mjs";
const $ = "TextInput", G = a.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: ${n["2x"]};
`, J = a.div`
  display: flex;
  height: ${({ $textSize: t }) => t === "small" ? n["8x"] : t === "medium" ? n["10x"] : t === "large" ? n["12x"] : n["8x"]};
  box-sizing: border-box;
  padding: ${n["1x"]} ${n["3x"]};
  align-items: center;
  gap: ${n["2x"]};
  align-self: stretch;
  border-radius: ${T["2x"]};
  ${({ $textSize: t, theme: r }) => {
  if (t === "small")
    return `
        --svg-wrapper-width: ${n["5x"]};
        --svg-wrapper-height: ${n["5x"]};
        input {
            font-size: ${e.regular.S.fontSize};
            line-height: ${e.regular.S.lineHeight};
            font-weight: ${e.regular.S.fontWeight};
          }
          span {
            font-size: ${e.regular.S.fontSize};
          }
          input::placeholder {
    color: ${r.components.textInput.textColorPlaceholder};
    font-weight: ${e.regular.S.fontWeight};
  }
        `;
  if (t === "medium")
    return `
              --svg-wrapper-width: ${n["6x"]};
              --svg-wrapper-height: ${n["6x"]};
              input {
                font-size: ${e.regular.M.fontSize};
                line-height: ${e.regular.M.lineHeight};
                font-weight: ${e.regular.M.fontWeight};
              }
              span {
                font-size: ${e.regular.M.fontSize};
              }
              input::placeholder {
    color: ${r.components.textInput.textColorPlaceholder};
    font-weight: ${e.regular.M.fontWeight};
  }
        `;
  if (t === "large")
    return `
        --svg-wrapper-width: ${n["6x"]};
        --svg-wrapper-height: ${n["6x"]};
       input {
          font-size: ${e.regular.L.fontSize};
          line-height: ${e.regular.L.lineHeight};
          font-weight: ${e.regular.L.fontWeight};;
        }
        span {
          font-size: ${e.regular.L.fontSize};
        }
         input::placeholder {
    color: ${r.components.textInput.textColorPlaceholder};
    font-weight: ${e.regular.L.fontWeight};
  }
              `;
}}
  border: ${({ disabled: t, $inputState: r, theme: o }) => `1px solid ${t ? o.components.textInput.disable.defaultBorder : o.components.textInput[r].defaultBorder}`};
  background-color: ${({ disabled: t, $inputState: r, theme: o }) => t ? o.components.textInput.disable.background : o.components.textInput[r].background};
  &:hover {
    ${({ disabled: t, $inputState: r, theme: o }) => {
  if (!t)
    return `border: 1px solid
        ${o.components.textInput[r].focusBorder};`;
}}
  }
  &:focus-within {
    outline: 1px solid
      ${({ disabled: t, $inputState: r, theme: o }) => {
  if (!t)
    return `${o.components.textInput[r].focusBorder};`;
}};
    border: 1px solid
      ${({ disabled: t, $inputState: r, theme: o }) => {
  if (!t)
    return `${o.components.textInput[r].focusBorder};`;
}};
  }
`, K = a.input`
  width: 100%;
  height: ${n["6x"]};
  flex: 1 0 0;
  padding: 0;
  background: var(--opacity-dark-00, rgba(255, 255, 255, 0));
  border-style: none;
  outline-style: none;
  color: ${(t) => t.disabled ? t.theme.components.textInput.textColorDisabled : t.theme.components.textInput.textColorFilled};
  font-family: ${E.body};
  font-size: ${j.body.medium.s.fontSize};
  font-style: normal;
  font-weight: ${e.regular.S.fontWeight};
  line-height: ${F.small};
`, x = a.div`
  width: var(--svg-wrapper-width-global, var(--svg-wrapper-width));
  height: var(--svg-wrapper-height-global, var(--svg-wrapper-height));
  display: flex;
  color: ${(t) => t.theme.components.textInput.textColorPlaceholder};
  svg,
  img {
    width: var(--svg-wrapper-width-global, var(--svg-wrapper-width));
    height: var(--svg-wrapper-height-global, var(--svg-wrapper-height));
  }
`, N = a(x)`
  margin-right: var(--icon-margin);
`, O = a(x)`
  margin-left: var(--icon-margin);
`, vt = _(
  ({
    startAdornment: t,
    endAdornment: r,
    startAdornmentProp: o,
    endAdornmentProp: d,
    defaultValue: w,
    disabled: g,
    isInvalid: u,
    showErrorIcon: Q = !0,
    placeholder: b = "Placeholder",
    helperText: v,
    value: y,
    isRequired: p = !1,
    required: c = p,
    inputRef: I,
    className: S,
    pattern: U,
    textSize: z = "medium",
    children: V,
    labelProp: C,
    infoProp: P,
    trailingText: W,
    // supporting backward compatability
    helperTextProp: i = {
      [u ? "secondaryProp" : "defaultProp"]: {
        helperText: v,
        id: `${u ? "invalid" : "valid"}_${$}_helperText`,
        ...u && { state: "error" }
      }
    },
    accessibilityOptions: k = {},
    ...f
  }, L) => {
    const s = M(D(f.id ?? $)), B = `${s.current}_message_id`, h = `${s.current}_label_id`, H = A("input", {
      ariaDisabled: g,
      ariaInvalid: i?.secondaryProp?.state === "caution" || i?.secondaryProp?.state === "error",
      ariaRequired: p || c,
      ariaLabelledBy: `${h} ${B}`,
      ...k
    });
    return /* @__PURE__ */ m(G, { ref: L, className: S, children: [
      /* @__PURE__ */ l(
        R,
        {
          labelProp: {
            showRequiredIndicator: p || c,
            id: h,
            htmlFor: f.id || s.current,
            ...C
          },
          infoProp: {
            infoText: "",
            infoType: "tooltip",
            popupTipHeader: "Info",
            ...P
          },
          trailingText: W
        }
      ),
      /* @__PURE__ */ m(
        J,
        {
          tabIndex: -1,
          $inputState: i?.secondaryProp?.state !== "none" && (i.secondaryProp?.state === "caution" || i.secondaryProp?.state === "error") ? i?.secondaryProp?.state : "default",
          $textSize: z,
          disabled: g,
          children: [
            (t || o?.startAdornment) && /* @__PURE__ */ l(N, { onClick: o?.onClick, children: t || o?.startAdornment }),
            /* @__PURE__ */ l(
              K,
              {
                disabled: g,
                value: y,
                placeholder: b,
                defaultValue: w,
                required: p || c,
                ref: I,
                id: s.current,
                ...f,
                ...H
              }
            ),
            (r || d?.endAdornment) && /* @__PURE__ */ l(O, { onClick: d?.onClick, children: r || d?.endAdornment })
          ]
        }
      ),
      /* @__PURE__ */ l(
        X,
        {
          secondaryProp: i?.secondaryProp,
          defaultProp: i?.defaultProp
        }
      )
    ] });
  }
);
export {
  vt as TextInput
};
